import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview",
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

export default Sentry;
